module.exports = __webpack_public_path__ + "static/media/kpmg-blue.14580512.png";